import { useState } from 'react';
import clsx from 'clsx';
import { CastTab } from './CastTab';
import { ScriptTab } from './ScriptTab';
import { StyleTab } from './StyleTab';

type Tab = 'cast' | 'script' | 'style';

const TABS: { id: Tab; label: string }[] = [
  { id: 'cast', label: 'Cast' },
  { id: 'script', label: 'Script' },
  { id: 'style', label: 'Style' },
];

export function RightRail() {
  const [active, setActive] = useState<Tab>('cast');

  return (
    <aside className="flex h-full w-full flex-col border-l border-line-1 bg-surface-1">
      <div className="flex border-b border-line-1 px-5">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            onClick={() => setActive(tab.id)}
            className={clsx(
              'relative -mb-px py-4 text-[13px] font-medium transition-colors',
              'mr-6 last:mr-0',
              active === tab.id ? 'text-text-1' : 'text-text-3 hover:text-text-2',
            )}
          >
            {tab.label}
            {active === tab.id && (
              <span className="absolute inset-x-0 bottom-0 h-0.5 bg-accent" />
            )}
          </button>
        ))}
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto p-5">
        {active === 'cast' && <CastTab />}
        {active === 'script' && <ScriptTab />}
        {active === 'style' && <StyleTab />}
      </div>
    </aside>
  );
}
